import React from 'react';
import styled from 'styled-components';
import { Grid, Cell } from '../grid';

const InfoBoxSectionContainer = styled.div`
  max-width: 990px;
  margin: 0 auto;
  padding: 0 25px;
`;

const BenefitsAreaBox = styled.div`
  display: flex;
  text-align: left;
`;

const IconContainer = styled.div`
  margin-right: 20px;
  img {
    width: 41px;
  }
`;

const TextContainer = styled.div`
  flex: 1;
`;

const Name = styled.div`
  font-size: 20px;
  font-weight: 600;
  line-height: 22px;
  padding-bottom: 8px;
  padding-top: 8px;
`;

const Description = styled.div`
  font-size: 18px;
  line-height: 24px;
  color: #666666;
`;

function BenefitsArea({ input }) {
  const { items } = input;

  return (
    <InfoBoxSectionContainer>
      <Grid columns={2} columnGap={'51px'} rowGap={'50px'}>
        {items.map((item, index) => {
          return (
            <Cell key={index} xs={2} sm={1}>
              <BenefitsAreaBox>
                <IconContainer>
                  <img src={item.icon.url} />
                </IconContainer>
                <TextContainer>
                  <Name>{item.name.text}</Name>
                  <Description>{item.description.text}</Description>
                </TextContainer>
              </BenefitsAreaBox>
            </Cell>
          );
        })}
      </Grid>
    </InfoBoxSectionContainer>
  );
}

export { BenefitsArea };
